export const SET_SELECTED_FILE_MILES = 'SET_SELECTED_FILE_MILES';
export const setSelectedFileMiles = miles => ({
	type: SET_SELECTED_FILE_MILES,
	payload: miles
});
